import React from 'react';

import useIsMobile from 'hooks/use-is-mobile';
import Layout from 'pages/Landings/components/Layout';
import Title from 'pages/Landings/components/Title';

import Demo from './components/Demo';
import Sales from './components/Sales';
import Support from './components/Support';
import useStyles from './styles';

const Contacts: React.FC = () => {
    const { classes } = useStyles();
    const isMobile = useIsMobile();
    return (
        <Layout>
            <div className={classes.container}>
                <Title variant={isMobile ? 'h1' : 'h2'} as={'h1'} className={classes.title}>
                    {'Reach out to Vulners team'}
                </Title>
                <p className={classes.subtitle}>
                    {'We want to keep things organized, but in reality we are a nimble startup'}
                    &nbsp;
                    {"and regardless of channel you chose, you'd talk to a member of a core team"}
                </p>
                <div className={classes.sections}>
                    <Demo className={classes.demo} />
                    <Sales className={classes.sales} />
                    <Support className={classes.support} />
                </div>
            </div>
        </Layout>
    );
};

export default Contacts;
